import React from "react";
import StandardLayout from "../../layouts/StandardLayout";

export default class BetHistory extends React.Component {
    render() {
        return <StandardLayout><iframe width="100%"
                       height={'800px'}
                src="https://datastudio.google.com/embed/reporting/af3206e5-17b8-414b-a4dd-63be89c202d2/page/p_9jeuyals0c"
                frameBorder="0" allowFullScreen></iframe>
        </StandardLayout>
    }
}